module.exports = __webpack_public_path__ + "static/img/200084.4cc06f5d.png";